import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IGetPriceGroupsDTO from "../../../models/DTO/IGetPriceGroupsDTO";
import IOnCreateVendorAddressDTO from "../../../models/DTO/IOnCreateVendorAddressDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnUpdateVendorAddressDTO from "../../../models/DTO/IOnUpdateVendorAddressDTO";
import IUpdateVendorAddressDTO from "../../../models/DTO/IUpdateVendorAddressDTO";
import IAddress from "../../../models/IAddress";
import ICreateVendorAddressDTO from "../../../models/DTO/ICreateVendorAddressDTO";
import ICatalog from "../../../models/ICatalog";
import IPrice_Group from "../../../models/IPrice_Group";
import AddressBlock from "../AddressBlock/AddressBlock";
import OwButton from "../OwButton/OwButton";
import OwCheckbox from "../OwCheckbox/OwCheckbox";
import OwLabel from "../OwLabel/OwLabel";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import OwTitle from "../OwTitle/OwTitle";

import "./EditAddressSidebar.scss";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import VendorContext from "../../../contexts/VendorContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";

type Props = {
    address?: IAddress;
    cancel: (refreshData?: boolean) => void;
    showInternalId?: boolean;
    vendorGuid?: string;
};

export const EditAddressSidebar = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [address, setAddress] = useState<IAddress>(props.address ? props.address : ({} as IAddress));
    const [catalogs, setCatalogs] = useState<ICatalog[]>([]);
    const [priceGroups, setPriceGroups] = useState<IPrice_Group[]>([]);

    const onUpdateVendorAddress = (data: IOnUpdateVendorAddressDTO) => {
        const notification: INotification = {
            message: "successfully_updated_address",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        props.cancel(true);
    };

    const onCreateVendorAddress = (data: IOnCreateVendorAddressDTO) => {
        const notification: INotification = {
            message: "successfully_created_address",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        props.cancel(true);
    };

    const onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        setCatalogs(data.catalogs);
    };

    const onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        setPriceGroups(data.priceGroups);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.AddressOnCreateVendorAddress, fn: onCreateVendorAddress },
        { endpoint: EndpointsEnum.AddressOnUpdateVendorAddress, fn: onUpdateVendorAddress },
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: onGetCatalogs },
        { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: onGetPriceGroups },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getCatalogs();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        if (catalogs) {
            getPriceGroups();
        }
    }, [address.catalog_id, catalogs]);

    const updateVendorAddress = () => {
        if (!props.address && !address) {
            return null;
        }

        const payload: IUpdateVendorAddressDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: props.vendorGuid,
            addressId: address.id,
            ...address,
        };

        socket.emit(EndpointsEnum.AddressUpdateVendorAddress, payload);
    };

    const createVendorAddress = () => {
        const payload: ICreateVendorAddressDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: props.vendorGuid,
            ...address,
        };

        socket.emit(EndpointsEnum.AddressCreateVendorAddress, payload);
    };

    const getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: vendorModel!.guid,
            onlyActive: true,
        };

        socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    const getPriceGroups = () => {
        if (!address.catalog_id) {
            return null;
        }

        let catalogGuid: string = "";

        for (const catalog of catalogs) {
            if (Number(catalog.id) === Number(address.catalog_id)) {
                catalogGuid = catalog.guid;
            }
        }

        if (catalogGuid.length) {
            const payload: IGetPriceGroupsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: vendorModel!.guid,
                catalogGuid,
            };

            socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        }
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const _address = { ...address };

        // @ts-expect-error
        _address[name] = value;

        setAddress(_address);

        // does this need to be in a useEffect when address changes?
        // if (name === "catalog_id") {
        //     getPriceGroups();
        // }
    };

    const save = () => {
        if (props.address) {
            updateVendorAddress();
        } else {
            createVendorAddress();
        }
    };

    return (
        <div className="EditAddressSidebar p-2">
            <div className={"h-7r"}>
                <div className="text-end">
                    <OwButton
                        className={"btn-sm btn-danger"}
                        centerIconClass={"far fa-times"}
                        fn={() => {
                            props.cancel(false);
                        }}
                    />
                </div>
                <OwTitle className={"mb-2"} leftIconName={"fad fa-building"} title={"address"} />
                <hr />
            </div>

            <div>
                <div>
                    <AddressBlock
                        address={address}
                        showName={true}
                        showCompanyName={true}
                        showEmail={true}
                        showPhoneFax={true}
                        fn={handleChange}
                        showInternalId={props.showInternalId}
                    />
                </div>

                <div className={"mt-2"}>
                    <OwCheckbox
                        label={"main_ship_to"}
                        fn={handleChange}
                        name={"is_vendor_main_ship_to"}
                        checked={address.is_vendor_main_ship_to}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div>
                    {catalogs && catalogs.length ? (
                        <div className={"mt-2"}>
                            <div>
                                <OwLabel noBottomMargin={true} title={"catalog_optional"} />
                            </div>
                            <OwSelectOption
                                valueProp={"id"}
                                titleProp={"name"}
                                fn={handleChange}
                                name={"catalog_id"}
                                options={catalogs}
                                showBlankFirst={true}
                                selectedOption={address}
                                selectedOptionProp={"catalog_id"}
                                emitOnLoad={true}
                                emitTarget={true}
                                nullIfBlank={true}
                            />
                        </div>
                    ) : null}

                    {priceGroups && priceGroups.length ? (
                        <div className={"mt-2"}>
                            <div>
                                <OwLabel noBottomMargin={true} title={"price_group_optional"} />
                            </div>
                            <OwSelectOption
                                valueProp={"id"}
                                titleProp={"value"}
                                fn={handleChange}
                                name={"price_group_id"}
                                options={priceGroups}
                                showBlankFirst={true}
                                selectedOption={address}
                                selectedOptionProp={"price_group_id"}
                                nullIfBlank={true}
                            />
                        </div>
                    ) : null}
                </div>

                <div className={"mt-2"}>
                    <OwButton title={"save"} className={"btn-primary"} fn={save} />
                </div>
            </div>
        </div>
    );
};
